export default "__VITE_ASSET__BdnV1fx8__"